// Scroll to (and focus) the first validation message in page order, clearing any sticky/fixed header.
const headerBottom = () => [...document.querySelectorAll("header, [data-sticky]")]
  .filter((h) => ["sticky", "fixed"].includes(getComputedStyle(h).position) && h.getBoundingClientRect().top <= 1)
  .reduce((m, h) => Math.max(m, h.getBoundingClientRect().bottom), 0);

export function scrollToFirstError(root) {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    const msg = (root || document).querySelector('[data-testid$="-error"], [role="alert"]');
    if (!msg) return;
    const id = (msg.dataset.testid || "").replace(/-error$/, "");
    const field = id ? document.getElementById(id) : null;
    const box = msg.closest("[data-field-invalid]") || msg.parentElement || msg;
    box.classList.remove("field-error-flash");
    void box.offsetWidth;
    box.classList.add("field-error-flash");
    const go = () => window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.scrollY - headerBottom() - 16), behavior: "smooth" });
    go();
    const sel = "input:not([type=hidden]):not([tabindex='-1']),textarea,select,button";
    const focusEl = field?.matches(sel) ? field : (field || box).querySelector(sel);
    focusEl?.focus({ preventScroll: true });
    // Re-check after late layout shifts (images/messages loading above the field).
    setTimeout(() => {
      const r = box.getBoundingClientRect();
      if (r.top < headerBottom() || r.bottom > window.innerHeight) go();
    }, 600);
  }));
}
